import { useMemo, useEffect, useCallback } from 'react';
/**
 * `useClickOutside` is a hook that handles click events outside a specific DOM element. A `onClickOutside` handler is invoked when a click or touch event happens outside the referenced element.
 */
export const useClickOutside = ({ elementRef, onClickOutside, containerRef, enabled = true, }) => {
    const elements = useMemo(() => (Array.isArray(elementRef) ? elementRef : [elementRef]), [elementRef]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = useCallback((e) => {
        if (!e.target || e.button > 0) {
            return;
        }
        if (elements.every((element) => { var _a; return !((_a = element.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)); })) {
            onClickOutside();
        }
    }, [onClickOutside, elements]);
    useEffect(() => {
        if (!enabled || elements.some((element) => !element.current)) {
            return;
        }
        const container = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || document;
        container.addEventListener('mousedown', handleClick);
        container.addEventListener('touchstart', handleClick, { passive: true });
        return () => {
            container.removeEventListener('mousedown', handleClick);
            container.removeEventListener('touchstart', handleClick);
        };
    }, [handleClick, enabled, elements, containerRef]);
};
